'use client'

import { useEffect } from 'react'

/**
 * Suppresses all console output in production to prevent
 * information leakage via browser DevTools.
 */
export function SuppressLogs() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const noop = () => {}
      console.log = noop
      console.warn = noop
      console.error = noop
      console.debug = noop
      console.info = noop
    }
  }, [])

  return null
}
